import { ExtendedBlob } from 'app/shared/models/extended-blob';

export function downloadFileFromExtendedBlob(extendedBlob: ExtendedBlob): void {
    const objectUrl = window.URL.createObjectURL(extendedBlob.blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = extendedBlob.metaData;
    document.body.appendChild(a);

    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
}
